/* KYME ACTIVE — cart drawer cross-sell (complete_the_look)
   Tapping "+ Add" on a rail card replaces the rail with a single focused
   panel for that product (thumbnail, title, price, sizes, back control) —
   so the size row is never ambiguous about which product it belongs to.
   Tapping a size adds it and returns to the rail. */
(function () {
  'use strict';

  function getElements(cross) {
    return {
      rail: cross.querySelector('[data-kyme-cross-rail]'),
      panels: cross.querySelectorAll('[data-kyme-cross-panel]')
    };
  }

  function showRail(cross) {
    var els = getElements(cross);
    if (els.rail) els.rail.removeAttribute('hidden');
    els.panels.forEach(function (p) { p.setAttribute('hidden', ''); });
  }

  function showPanel(cross, panelId) {
    var els = getElements(cross);
    var target = panelId ? cross.querySelector('#' + panelId) : null;
    if (!target) return;
    if (els.rail) els.rail.setAttribute('hidden', '');
    els.panels.forEach(function (p) {
      if (p === target) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  function addCrossItem(button, variantId) {
    var label = button.textContent;
    button.disabled = true;
    button.textContent = '...';

    var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var cartDrawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (response) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          try {
            cartDrawer.renderContents(response);
          } catch (err) {
            console.error('[kyme] cart-drawer renderContents failed; item was added to cart.', err);
          }
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[kyme] add to cart failed', err);
        button.disabled = false;
        button.textContent = label;
      });
  }

  /* Scroll-down affordance for the line-item region. Native cart-drawer.js
     renderContents() does `document.querySelector('#CartDrawer').innerHTML =
     ...` on every add/quantity-change/remove, which destroys and recreates
     <cart-drawer-items> as a brand-new node each time — any listener bound
     directly to it would go dead after the first re-render. #CartDrawer
     itself is never replaced, only its children, so it's the stable anchor:
     watch it for childList changes and rebind to whichever
     <cart-drawer-items> node currently exists. */
  function initScrollAffordance() {
    var root = document.getElementById('CartDrawer');
    if (!root) return;

    var bound = null;

    function update(items) {
      var maxScroll = items.scrollHeight - items.clientHeight;
      var canScroll = maxScroll > 1 && items.scrollTop < maxScroll - 1;
      items.classList.toggle('kd-can-scroll-down', canScroll);
    }

    function bindTo(items) {
      if (bound && bound.items === items) {
        update(items);
        return;
      }
      if (bound) {
        bound.items.removeEventListener('scroll', bound.onScroll);
        if (bound.resizeObserver) bound.resizeObserver.disconnect();
      }
      var onScroll = function () { update(items); };
      items.addEventListener('scroll', onScroll, { passive: true });
      var resizeObserver = null;
      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(function () { update(items); });
        resizeObserver.observe(items);
      }
      bound = { items: items, onScroll: onScroll, resizeObserver: resizeObserver };
      update(items);
    }

    function sync() {
      var items = root.querySelector('cart-drawer-items');
      if (items) bindTo(items);
    }

    new MutationObserver(sync).observe(root, { childList: true });
    window.addEventListener('resize', function () {
      if (bound) update(bound.items);
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAffordance);
  } else {
    initScrollAffordance();
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-kyme-cross-open]');
    if (openBtn) {
      var cross = openBtn.closest('[data-kyme-cross]');
      if (cross) showPanel(cross, openBtn.getAttribute('data-panel'));
      return;
    }

    var backBtn = e.target.closest('[data-kyme-cross-back]');
    if (backBtn) {
      var backCross = backBtn.closest('[data-kyme-cross]');
      if (backCross) showRail(backCross);
      return;
    }

    var sizeBtn = e.target.closest('.kd__cross-size');
    if (sizeBtn && !sizeBtn.disabled) {
      var sizeCross = sizeBtn.closest('[data-kyme-cross]');
      addCrossItem(sizeBtn, sizeBtn.getAttribute('data-variant-id'));
      if (sizeCross) showRail(sizeCross);
    }
  });
})();
